<template>
    <div class="dot"></div>
</template>

<script>
export default {
    name: 'Orangedot'
}
</script>

<style scoped>
.dot{
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: #f05d2e;
    border-radius: 100%;
}
</style>